import * as React from 'react';
import { RESIZER_ATTRIBUTE } from './consts';
import { reduceMousePosition } from './reduceMousePosition';
import { ResizeMouseEventHandler, State } from './types';
import { getContainerState, updateConfigsFromBoxes } from './utils';

type GetMouseDownHandlerArgs = {
  containerRef: React.RefObject<HTMLDivElement | null>;
  setState: React.Dispatch<React.SetStateAction<State>>;
  getValueFromDOMRect: (rect: DOMRect) => number;
  onResizeEnd?: ResizeMouseEventHandler;
  onResizeStart?: ResizeMouseEventHandler;
};
export const getMouseDownHandler =
  ({
    containerRef,
    setState,
    getValueFromDOMRect,
    onResizeEnd,
    onResizeStart,
  }: GetMouseDownHandlerArgs) =>
  (event: React.MouseEvent) => {
    const { target, clientX, clientY } = event;
    if (
      !(
        containerRef?.current &&
        target instanceof HTMLDivElement &&
        target.hasAttribute(RESIZER_ATTRIBUTE)
      )
    ) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();

    const { resizers, boxes, containerBox } = getContainerState(
      containerRef.current
    );

    const activeResizerIndex = resizers.indexOf(target);

    const startState = {
      x: clientX,
      y: clientY,
      boxes,
      containerBox,
    };

    const mouseMoveHandler = ({ clientX: x, clientY: y }: MouseEvent) =>
      setState(state => reduceMousePosition(state, { x, y }));

    const mouseUpHandler = () => {
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
      setState(state => ({ ...state, activeResizerIndex: -1 }));
      if (containerRef.current) {
        onResizeEnd?.(getContainerState(containerRef.current).boxes);
      }
    };

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);

    setState(state => ({
      ...state,
      startState,
      configs: updateConfigsFromBoxes({
        configs: state.configs,
        boxes,
        containerBox,
        getValueFromDOMRect,
        isStyleInitialized: state.isStyleInitialized,
      }),
      activeResizerIndex,
    }));

    if (containerRef.current) {
      onResizeStart?.(getContainerState(containerRef.current).boxes);
    }
  };
